import type { HelpFile } from '../../types/help'
import { TypeScopeFilterTestIds } from '../../../testids/TypeScopeFilterTestIds'

export const typeScopeFilterHelp: HelpFile = {
  docPage: '/docs/admin/attributes',
  texts: {
    [TypeScopeFilterTestIds.typeScopeAll]:
      'Definitionen aus allen Typen und dem globalen Bereich gemeinsam anzeigen.',
    [TypeScopeFilterTestIds.typeScopeGlobal]:
      'Nur Definitionen mit globalem Geltungsbereich anzeigen — nicht an einen bestimmten Typ gebunden.',
  },
}
